import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBooleanGroupIntersect2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBooleanGroupIntersect2"><Path d="M8.5 8.5V15.5H15.5M8.5 5V2.5H11M19 2.5H21.5V5M14 2.5H16M21.5 8V10M21.5 13V15.5H19" stroke="currentColor" strokeLinecap="square"/><Path d="M2.5 14V16M2.5 11V8.5H5M8.5 8.5H15.5V15.5M15.5 19V21.5H13M10 21.5H8M5 21.5H2.5V19" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBooleanGroupIntersect2;
